import { render, staticRenderFns } from "./gemstones.vue?vue&type=template&id=72ab4019&"
import script from "./gemstones.vue?vue&type=script&lang=js&"
export * from "./gemstones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports